import { StatusCdo } from "utils/interfaces";

export const availableCdoByPos = (credentials: any, pointOfSale: any): boolean => {
    if (!!pointOfSale) {
        let credential = credentials?.filter((c: any) => c?.id === pointOfSale?.id)[0];
        return credential?.cdo_status_id === StatusCdo.ENABLED;
    }
};